module.exports = __webpack_public_path__ + "img/worldnet1.5e1aa055.jpg";